module.exports = __webpack_public_path__ + "img/avatar.cf3a9ccf.png";